import { render } from "./DevicesInverter.vue?vue&type=template&id=f89dc670"
import script from "./DevicesInverter.vue?vue&type=script&lang=js"
export * from "./DevicesInverter.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__